import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { useProject } from "@/hooks/use-project";
import { PreconReportBuilder } from "@/components/reports/precon-report-builder/precon-report-builder";

export const Route = createFileRoute(
  "/projects/$projectId_/reports/new/precon/",
)({
  component: PreconBuilderPage,
});

export function PreconBuilderPage() {
  // `from` is the route ID (the `$projectId_` segment un-nests this page from
  // the project shell); the URL it matches is still
  // /projects/$projectId/reports/new/precon.
  const { projectId } = useParams({
    from: "/projects/$projectId_/reports/new/precon/",
  });
  const { data: project, isLoading, refetch } = useProject(projectId);

  if (!project) {
    // First load: the AuthGuard spinner covers this paint — render nothing.
    if (isLoading) return null;
    // Errored / exhausted with no data. Un-nested from the project shell,
    // there is no layout ErrorShell above this route any more — without this
    // branch a failed project fetch would be a permanently blank page.
    // Mirrors the layout ErrorShell's tone, minus the project chrome.
    return (
      <div className="flex h-app-screen flex-col items-center justify-center gap-2 px-6 text-center">
        <p className="text-sm text-muted-foreground">
          Couldn&apos;t load this project — check your connection and try
          again.
        </p>
        <Button variant="outline" size="sm" onClick={() => refetch()}>
          Retry
        </Button>
        <Link
          to="/projects/$projectId/records"
          params={{ projectId }}
          className="text-sm text-primary underline-offset-4 hover:underline"
        >
          Back to records
        </Link>
      </div>
    );
  }

  return <PreconReportBuilder projectId={projectId} project={project} />;
}
